import React from 'react';
import { Autocomplete, Typography } from 'seagull';
import { matchSorter } from 'match-sorter';
export function QBOAccountField(_ref) {
  let {
    options,
    onChange: _onChange,
    textFieldProps,
    selectedOption,
    'data-testid': testid,
    noOptionsText = 'No QuickBooks accounts'
  } = _ref;
  return /*#__PURE__*/React.createElement(Autocomplete, {
    "data-testid": testid,
    value: selectedOption,
    options: options,
    onChange: (_, newOption) => _onChange(newOption),
    renderOption: _ref2 => {
      let {
        name
      } = _ref2;
      return /*#__PURE__*/React.createElement(Typography, {
        ellipsis: true
      }, name);
    },
    getOptionSelected: (option, value) => option.id === value.id,
    getOptionLabel: option => option.name,
    filterOptions: (options, _ref3) => {
      let {
        inputValue
      } = _ref3;
      return matchSorter(options, inputValue, {
        keys: ['name']
      });
    },
    noOptionsText: noOptionsText,
    textFieldProps: textFieldProps,
    selectOnFocus: true,
    disableClearable: true,
    multiple: false,
    freeSolo: false
  });
}